// import React, { useEffect, useId, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// export default function SidebarComponent() {
//   const controller = new AbortController();
//   const [hide, setHide] = useState(false);
//   const [width, setWidth] = useState(0); // State to store the width
//   const divRef = useRef(null); // Ref to access the div

//   useEffect(() => {
//     // Get the width when the component mounts
//     if (divRef.current) {
//       const currentWidth = divRef.current.getBoundingClientRect().width;
//       //console.log(currentWidth);
//       setWidth(currentWidth);
//       if (currentWidth < 100) {
//         setHide(true);
//       }
//     }
//   }); // Only runs on mount

//   useEffect(() => {
//     return () => {
//       controller.abort();
//     };
//   }, []);
//   //console.log("divRef.current", divRef?.current?.getBoundingClientRect().width);
//   return (
//     <>
//       <aside
//         ref={divRef}
//         className="main-sidebar sidebar-dark-primary elevation-4"
//       >
//         <a href="/" className="brand-link">
//           <img
//             src="./assets/img/Slattery-Energy-Group-Icon.png"
//             alt="Slattery Logo"
//             className="brand-image img-circle elevation-3"
//             style={{ opacity: ".8" }}
//           />
//           <span className="brand-text font-weight-light">
//             <img
//               src="./assets/img/Slattery-Energy-Group-Light.png"
//               className="img-fluid logo-brand-image"
//             />
//           </span>
//         </a>

//         <div className="sidebar">
//           <nav className="mt-2">
//             <ul
//               className="nav nav-sidebar flex-column"
//               data-widget="treeview"
//               role="menu"
//               data-accordion="false"
//             >
//               <div id="main">
//                 <div className="accordion" id="faq">
//                   <div className="card1">
//                     <Link to="/dashboard" className="nav-link">
//                       <i className="nav-icon fas fa-th" />
//                       <p>Dashboard</p>
//                     </Link>
//                   </div>
//                   <div className="card1">
//                     <Link to="/lead" className="nav-link">
//                       <i className="nav-icon fas fa-plus-circle"></i>
//                       <p>Lead</p>
//                     </Link>
//                   </div>
//                   <div className="card1">
//                     <Link to="/projects" className="nav-link">
//                       <i className="nav-icon fas fa-clipboard"></i>
//                       <p>Projects</p>
//                     </Link>
//                   </div>
//                   <div className="card1">
//                     <Link to="/quotes" className="nav-link">
//                       <i className="nav-icon fas fa-file-alt"></i>
//                       <p>Quotes</p>
//                     </Link>
//                   </div>
//                   <div className="card1">
//                     <Link to="/bid" className="nav-link">
//                       <i className="nav-icon fas fa-gavel"></i>
//                       <p>Bid</p>
//                     </Link>
//                   </div>
//                   <div className="card1">
//                     <div>
//                       <Link to="/contracts" className="nav-link">
//                         <i className="nav-icon fas fa-file-signature"></i>
//                         <p>Contracts</p>
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="card1">
//                     <div>
//                       <Link to="/commision" className="nav-link">
//                         <i className="nav-icon fas fa-file-invoice-dollar"></i>
//                         <p>Commision</p>
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="card">
//                     <div className="card-header" id="faqhead81">
//                       <a
//                         href="#"
//                         className="nav-link custommenuheight"
//                         data-toggle="collapse"
//                         data-target="#faq81"
//                         aria-expanded="true"
//                         aria-controls="faq81"
//                       >
//                         <i className="nav-icon fas fa-th-large"></i>
//                         <p style={{ color: "white" }}>Master</p>
//                       </a>
//                     </div>
//                     <div
//                       id="faq81"
//                       className="collapse"
//                       aria-labelledby="faqhead81"
//                       data-parent="#faq81"
//                     >
//                       <div className="card-body p-0">
//                         <ul
//                           className="nav nav-treeview"
//                           style={{ display: "block" }}
//                         >
//                           <div className="card">
//                             <div>
//                               <Link to="/contacts" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Contacts</p>
//                               </Link>
//                               <Link to="/customer" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Customer</p>
//                               </Link>
//                               <Link to="/supplier" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Supplier</p>
//                               </Link>
//                               <Link to="/utility-company" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Utility Company</p>
//                               </Link>
//                               <Link to="/vendor" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Vendor</p>
//                               </Link>
//                               <Link to="/agent" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Agent</p>
//                               </Link>
//                               <Link to="/feature" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Feature</p>
//                               </Link>
//                               <Link to="/entity-info" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Entity</p>
//                               </Link>
//                               <Link
//                                 to="/report-configuration"
//                                 className="nav-link"
//                               >
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>Report Configuration</p>
//                               </Link>
//                             </div>
//                           </div>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="card">
//                     <div className="card-header" id="faqhead82">
//                       <a
//                         href="#"
//                         className="nav-link"
//                         data-toggle="collapse"
//                         data-target="#faq82"
//                         aria-expanded="true"
//                         aria-controls="faq82"
//                       >
//                         <i className="nav-icon fas fa-users"></i>
//                         <p style={{ color: "white" }}>User Management</p>
//                       </a>
//                     </div>
//                     <div
//                       id="faq82"
//                       className="collapse"
//                       aria-labelledby="faqhead82"
//                       data-parent="#faq82"
//                     >
//                       <div className="card-body p-0">
//                         <ul
//                           className="nav nav-treeview"
//                           style={{ display: "block" }}
//                         >
//                           <div className="card">
//                             <div>
//                               <Link to="/user" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>User</p>
//                               </Link>
//                               <Link to="/userrole" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>User Role</p>
//                               </Link>
//                               <Link to="/usertype" className="nav-link">
//                                 <i className="far fa-circle nav-icon" />
//                                 <p>User Type</p>
//                               </Link>
//                             </div>
//                           </div>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </ul>
//           </nav>
//         </div>
//       </aside>
//     </>
//   );
// }


import React, { useState, useEffect, Fragment } from "react";
import { axiosPost } from "../apis/useAxios";
import {
  ClearSessionItems,
  LocalStorage,
  getCurrentLocation,
} from "../helper/appsession";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { LoginAssetType } from "../helper/fixcode";
import { LogoutLoader } from "./Shared/PageLoader";
import TabStorage from "../helper/TabStorage";

const SideBarComponent = () => {
  const [state, setState] = useState({
    userFeatureSetup: TabStorage.getItem("user"),
    roleSetup: null,
    isLoading: false,
    menuHtml: null,
    loadPanelVisible: false
  });

  useEffect(() => {
    // debugger
    let user = TabStorage.getItem("user");  // ✅ returns object, not Promise
    console.log(user.name); // "Mustafa"
    const menuHtmlItem = getMenuHtml(user?.featureList);
    // console.log("TrackingGuid: " + TabStorage.TrackingGuid);
    setState(prev => ({ ...prev, menuHtml: menuHtmlItem }));
  }, []);

  const getMenuHtml = (menuFeature) => {
    console.log("menuFeature", menuFeature)
    let menuHtmlItem = [];
    // menuFeature = JSON.parse(JSON.stringify(menuFeature));
    menuFeature?.forEach((menu) => {
      if (menu.subFeatureId === 0) {
        // debugger
        let childMenu = menuFeature.filter(
          (el) => el.subFeatureId === menu.id
        );
        const menuName = menu.displayName;
        if (childMenu.length > 0) {
          // debugger
          menuHtmlItem.push(
            <div className="card" key={menu.id}>
              <div className="card-header nav-link" id={"faqhead" + menu.id}>
                <a
                  href="#"
                  className="nav-link collapsed"
                  data-toggle="collapse"
                  data-target={"#faq" + menu.id}
                  aria-expanded="true"
                  aria-controls={"faq" + menu.id}
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p className="brand-text">{menuName}</p>
                </a>
              </div>
              <div
                id={"faq" + menu.id}
                className="collapse"
                aria-labelledby={"faqhead" + menu.id}
                data-parent="#faq"
              >
                <div className="card-body p-0">
                  <ul key={menu.id} className="nav nav-treeview">
                    {subMenuHtml(childMenu)}
                  </ul>
                </div>
              </div>
            </div>
          );
        } else if (menuName === "GPS Tracking") {
          TabStorage.trackingGuid() !== "00000000-0000-0000-0000-000000000000" &&
            menuHtmlItem.push(
              <div className="card" key={menu.featureId}>
                <div id={"faqhead" + menu.featureId}>
                  <a
                    href="#"
                    onClick={(e) => redirectToTracking(e)}
                    className="nav-link"
                  >
                    <Icon icon={menu.iconName} className="nav-icon" />
                    <p className="brand-text">{menu.displayName}</p>
                  </a>
                </div>
              </div>
            );
        } else if (menuName === "Leads") {
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <a
                  onClick={(e) => {
                    window.history.replaceState(null, null, "/");
                    window.location.href = "/leads";
                  }}
                  className="nav-link"
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p className="brand-text">{menu.displayName}</p>
                </a>
                <Link
                  to={{
                    pathname: "/leads",
                    state: { TabId: 0 },
                  }}
                ></Link>
              </div>
            </div>
          );
        } else if (menuName === "Ticket") {
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <a
                  href="https://ticketing.utwiz.com/"
                  target="_new"
                  className="nav-link"
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p className="brand-text">{menu.displayName}</p>
                </a>
              </div>
            </div>
          );
        } else {
          menuHtmlItem.push(
            <div className="card" key={menu.id}>
              <div id={"faqhead" + menu.id}>
                <a href={menu.requestPath} className="nav-link">
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p className="brand-text">{menu.displayName}</p>
                </a>
              </div>
            </div>
          );
        }
      }
    });
    return menuHtmlItem;
  };

  const subMenuHtml = (menuFeature) =>
    menuFeature.map((subchild) => (
      <div className="card" key={subchild.featureId}>
        <div id={"faqhead" + subchild.featureId}>
          <a
            href={subchild.requestPath}
            className="nav-link"
            title={subchild.menuName}
          >
            <Icon icon={subchild.iconName} className="nav-icon" />
            <p className="brand-text">{subchild.displayName}</p>
          </a>
        </div>
      </div>
    ));

  const handleOnLogout = async (e) => {
    e.preventDefault();
    try {
      setState(prev => ({ ...prev, isLoading: true }));
      let userId = TabStorage.userId();
      const { lat, lng } = await TabStorage.getCurrentLocation();
      let url = `/authenticate/user/${userId}/logout`;
      const response = await axiosPost(url, {
        SessionId: TabStorage.sessionId(),
        AssetTypeId: LoginAssetType.Web,
        Latitude: lat,
        Longitude: lng,
      });
      if (response.success) {
        window.ameyo.integration.doLogout();
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }
    TabStorage.clearSessionItems();
    window.location.href = "/";
  };

  const redirectToTracking = async (e) => {
    e.preventDefault();
    setState(prev => ({ ...prev, loadPanelVisible: true }));
    try {
      const redirectdata = await axiosPost(
        process.env.REACT_APP_CUSTOMER_API_URL + "RedirectUser/external-token",
        {
          Source: "zenplus",
          Token: TabStorage.trackingGuid(),
        }
      );

      if (redirectdata.isSuccess) {
        setState(prev => ({ ...prev, loadPanelVisible: false }));
        if (redirectdata.payload != null) {
          window.open(
            process.env.REACT_APP_CUSTOMER_SITE_URL +
            "?userguid=" +
            TabStorage.trackingGuid() +
            "&source=zenplus",
            "_blank"
          );
        }
      }
    } catch (err) {
      console.log("Error in redirectToTracking function", err);
      setState(prev => ({ ...prev, loadPanelVisible: false }));
    }
  };

  return (
    <>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <Link href="/" className="brand-link">
          <img
            src="./assets/img/Slattery-Energy-Group-Icon.png"
            alt="Slattery Logo"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8" }}
          />
          <span className="brand-text font-weight-light">
            <img
              src="./assets/img/Slattery-Energy-Group-Light.png"
              className="img-fluid logo-brand-image"
            />
          </span>
        </Link>
        <div className="sidebar">
          <nav>
            {/* <ul className="nav nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false"> */}
            <div id="main">
              <div className="accordion" id="faq">
                {state.menuHtml}
                <div className="card">
                  <div id="faqhead100">
                    <a
                      href="#"
                      className="nav-link"
                      onClick={(e) => handleOnLogout(e)}
                    >
                      <Icon icon="material-symbols:logout" width="20" height="20" className="nav-icon" />
                      <p className="brand-text">Logout</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* </ul> */}
          </nav>

        </div>
      </aside>
      {state.isLoading && <LogoutLoader />}
    </>
  );
};

export default SideBarComponent;